import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import {
  Grid,
  FormControl,
  InputLabel,
} from "@material-ui/core";

import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker"
import { appConstants } from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  root: {
    flexGrow: 1,
    paddingLeft: '15px'

  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {
    marginTop: "0px",
    width: '100%'
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "black",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
});

function settlementPanel(props) {
  const { airports, user, classes, selectChange, data, startDate, endDate,
    handleDateChange, onSearch, startLabel, endLabel, airportCode, AirlineId, FlightNumber, flightNumbers } = props;
  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item lg={3}>
          <div className="picker">
            <InlineDatePicker Date={startDate} handleDateChange={(date) => handleDateChange(date, 'startDate')} label={startLabel} />
          </div>

        </Grid>
        <Grid item lg={3}>
          <div className="picker">
            <InlineDatePicker Date={endDate} handleDateChange={(date) => handleDateChange(date, 'endDate')} label={endLabel} />
          </div>

        </Grid>
        <Grid item lg={2}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
              options={data.map((option) => ({ value: option.AirlineId, label: option.Airline }))}
              handleSelectChange={(e, name) => selectChange(e, name)}
              selectLabel={"Airlines"}
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              name={"AirlineId"}
              selectedOption={AirlineId}
            />
            {/* <Select
              value={AirlineId}
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              onChange={selectChange}
              input={<Input name="airline" id="airline-label-placeholder" />}
              // displayEmpty
              name="AirlineId"
              className={classes.selectEmpty}
            >
              <MenuItem value="-1">All Airlines</MenuItem>
              {data.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.AirlineId}
                  className={classes.select}
                >
                  {option.Airline}
                </MenuItem>
              ))}
            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item lg={2}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              All Flights
            </InputLabel>
            <AutocompleteSelect
              options={flightNumbers.map(option => ({ value: option.FlightNumber, label: option.FlightNumber }))}
              name={"FlightNumber"}
              selectLabel={"Flight Number"}
              handleSelectChange={(e, name) => selectChange(e, name)}
              selectedOption={FlightNumber}

            />

          </FormControl>
        </Grid>
        <Grid item lg={2}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airports
            </InputLabel>
            <AutocompleteSelect
              options={airports.map(option => ({ value: option.Code, label: option.Name }))}
              name={"airportCode"}
              handleSelectChange={(e, name) => selectChange(e, name)}
              disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
              selectedOption={airportCode}
            />
            {/*<Select
                value={airportCode}
                disabled={(user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location)}
                onChange={selectChange}
                input={<Input name="airportCode" id="airport-label-placeholder" />}
                // displayEmpty
                name="airportCode"
                className={classes.selectEmpty}
            >
              <MenuItem value="-1">All Airports</MenuItem>
                {airports.map((option, i) => (
                    <MenuItem
                        key={i}
                        value={option.Code}
                        className={classes.select}
                    >
                        {option.Name}
                    </MenuItem>
                ))}
            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item lg={2}>
          <Button color={"regional"} onClick={() => onSearch()}>Search</Button>
        </Grid>
      </Grid>

    </div>
  );
}

export default withStyles(styles)(settlementPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/OutstandingSettlement/OutstandingSettlementsPanel.jsx